import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomPreloadStrategy implements PreloadingStrategy {
  
  // Rutas prioritarias que se deben cargar inmediatamente
  private priorityRoutes = [
    'Videoteca',
    'dashboard', 
    'students',
    'products'
  ];

  // Rutas secundarias que se cargan después
  private secondaryRoutes = [
    'leads',
    'Colaboradores',
    'users'
  ];

  preload(route: Route, fn: () => Observable<any>): Observable<any> {
    const routePath = route.path || '';
    // Permitir desactivar el preloading para diagnósticos: ?nopreload=1 o localStorage.NOPRELOAD='1'
    try {
      const url = new URL(window.location.href);
      const noPre = url.searchParams.get('nopreload') === '1' || localStorage.getItem('NOPRELOAD') === '1';
      if (noPre) {
        return of(null);
      }
    } catch {}
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // Safari: habilitar preload solo para rutas críticas (Videoteca) con un pequeño delay
    if (isSafari) {
      if (this.priorityRoutes.includes(routePath)) {
        return timer(500).pipe(mergeMap(() => fn()));
      }
      return of(null);
    }
    
    console.log('🔄 [PRELOAD] Evaluando ruta para preload:', routePath);
    
    // Precargar rutas prioritarias inmediatamente
    if (this.priorityRoutes.includes(routePath)) {
      console.log('⚡ [PRELOAD] Cargando ruta prioritaria:', routePath);
      return fn();
    }
    
    // Precargar rutas secundarias con delay
    if (this.secondaryRoutes.includes(routePath)) {
      console.log('⏱️ [PRELOAD] Cargando ruta secundaria con delay:', routePath);
      return timer(2000).pipe(
        mergeMap(() => fn())
      );
    }
    
    // Otras rutas se cargan con delay mayor
    console.log('⏳ [PRELOAD] Cargando ruta normal con delay:', routePath);
    return timer(5000).pipe(
      mergeMap(() => fn())
    );
  }
}
